module.exports = __webpack_public_path__ + "img/bscscan.ac89f7d5.png";